__turbopack_context__.v({
  "item": "dZ8UMa_item",
  "itemIcon": "dZ8UMa_itemIcon",
  "itemLabel": "dZ8UMa_itemLabel",
  "itemWrapper": "dZ8UMa_itemWrapper",
  "root": "dZ8UMa_root",
});
